import { Injectable } from '@angular/core';
import { ProductService } from '@shared/services/product/product.service';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { PATHS } from '@shared/constants/paths';
import { Router } from '@angular/router';
import { IListUpdatesState } from '@usf/ngrx-list';
import { ListUpdatesService } from '../services/list-updates.service';

@Injectable({
  providedIn: 'root',
})
export class ListUpdatesResolverService {
  constructor(
    private listUpdatesService: ListUpdatesService,
    private productService: ProductService,
    private router: Router,
  ) {}

  resolve(): Observable<number[]> {
    return this.getForcedUpdates();
  }

  getForcedUpdates() {
    return this.listUpdatesService.getListUpdateState$().pipe(
      filter((listUpdatesState: IListUpdatesState) => listUpdatesState?.loaded),
      take(1),
      map((listUpdatesState: IListUpdatesState) => {
        const productNumbers: number[] = [];

        if (listUpdatesState?.listUpdates?.length <= 0) {
          this.router.navigate([PATHS.LISTS]);
        }

        for (const listUpdate of listUpdatesState.listUpdates) {
          productNumbers.push(
            ...[listUpdate.oldProductNumber, listUpdate.newProductNumber],
          );
        }

        this.productService.loadProductDetails(productNumbers);
        this.productService.loadProducts(productNumbers);
        return productNumbers;
      }),
    );
  }
}
